import { Helmet } from "react-helmet-async";
import { PORTRAIT_PRIMARY } from "@/lib/assets";

const SITE_NAME = "Nishant Gathwal";
const DEFAULT_DESC =
  "Nishant Gathwal is a UX designer in New Delhi with 8+ years designing product experiences across travel, edtech, and HR & enterprise software.";

/**
 * Per-page SEO: title, description, canonical, Open Graph, Twitter cards
 * and optional JSON-LD structured data.
 */
export const Seo = ({ title, description, path = "", image, type = "website", jsonLd }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — UX Designer in New Delhi`;
  const desc = description || DEFAULT_DESC;
  const img = image || PORTRAIT_PRIMARY;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {origin && <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {origin && <meta property="og:url" content={url} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
